exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Based on the `stage-selector_raised` class */\ndiv[class*=\"stage-selector_header_\"],\ndiv[class*=\"sprite-selector_sprite-selector\"],\ndiv[class*=\"sprite-info_sprite-info\"],\ndiv[class*=\"monitor_list-body\"] {\n  transition: background-color 0.25s ease;\n}\n.sa-dragged-over,\n.sa-dragged-over div[class*=\"stage-selector_header_\"],\n.sa-dragged-over div[class*=\"sprite-info_sprite-info\"],\n.sa-dragged-over div[class*=\"monitor_list-body\"] {\n  background-color: hsla(0, 100%, 77%, 1) !important;\n}\n", ""]);

// exports
